const Footer = () => {
	return (
		<footer className="footer">
			<a
				href="https://github.com/psyjulga/gardenstores-project"
				target="_blank"
				rel="noreferrer"
				title="Code on Github"
			>
				Open-source code
			</a>
			🐞by Julia Bestgen💃
		</footer>
	)
}

export default Footer
